export const isUsedHoursLessThanOne = (balance) => {
	return Math.round(balance / 60) <= 1;
};

export const formatHoursTracking = (balance, limit) => {
	const clampedBalance = Math.max(balance, 0);
	const hours = Math.floor(clampedBalance / 60);
	const minutes = clampedBalance % 60;
	const formattedBalance = minutes ? `${hours}h${String(minutes).padStart(2, '0')}m` : `${hours}h`;
	const limitHours = Math.round(limit / 60);
	return `${formattedBalance}/${limitHours}`;
};
